import { Play } from "lucide-react";

interface SpecialEventMediaItemProps {
  imageUrl: string;
  videoUrl?: string | null;
  title: string;
  mediaType: string;
  onClick: () => void;
}

const getYouTubeVideoId = (url: string): string => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : '';
};

export const SpecialEventMediaItem = ({ 
  imageUrl, 
  videoUrl, 
  title, 
  mediaType, 
  onClick 
}: SpecialEventMediaItemProps) => {
  const isYouTube = videoUrl && (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be'));

  return (
    <div 
      className="relative aspect-video cursor-pointer group overflow-hidden"
      onClick={onClick}
    >
      {mediaType === "video" && videoUrl ? (
        <div className="relative w-full h-full bg-black">
          {isYouTube ? (
            <img
              src={imageUrl || `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/maxresdefault.jpg`}
              alt={title}
              className="w-full h-full object-cover"
            />
          ) : (
            <video
              src={videoUrl}
              className="w-full h-full object-cover"
              poster={imageUrl}
            />
          )}
          <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/50 transition-colors">
            <Play className="w-16 h-16 text-white" />
          </div>
        </div>
      ) : (
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      )}
    </div>
  );
};
